/* eslint-disable @typescript-eslint/no-explicit-any */
export const calcBets = (
  modifier: string,
  legs: any, //number
  combine: any, //number
  runners: any,
  baseAmount: any, //number
  maxAmount: any, //number
  unordered: boolean,
  races: any //number
) => {
  if (
    baseAmount < 0.01 ||
    maxAmount < 0.01 ||
    runners == null ||
    runners.length < 1 ||
    legs < 1 ||
    combine < 0)
    return -1;
  const maxCount = maxAmount / baseAmount;
  let count = 0;
  let actualRunners = [];
  if (typeof combine == 'undefined') {
      combine = 1;
  }
  let ordered: any;
  ordered = 1;
  if (typeof unordered != 'undefined') {
      ordered = !unordered;
  }
  switch (modifier.toLowerCase()) {
      case "box":
          if (runners.length !== 1) return -1;
          actualRunners.push(runners[0]);
          for (let i = 1; i < legs; i++) {
              actualRunners.push(runners[0]);
          }
          count = countBets(actualRunners, legs, combine, maxCount, ordered);
          break;
      case "powerbox":
          if (runners.length !== legs || !ordered) return -1;
          count = countKeyBoxBets(runners, legs, combine, true, maxCount, ordered);
          break;
      case "leading":
          if (runners.length !== 2 || !ordered) return -1;
          actualRunners.push(runners[0]);
          actualRunners.push(runners[1]);
          for (let j = 2; j < legs; j++) {
              actualRunners.push(runners[1]);
          }
          count = countBets(actualRunners, legs, combine, maxCount, ordered);
          break;
      case "keywheel":
          if (runners.length !== 2 || !ordered) return -1;
          for (let k = 0; k < legs; k++) {
              actualRunners = [];
              for (let l = 0; l < legs; l++) {
                  if (l === k) {
                      actualRunners.push(runners[0]);
                      continue;
                  }
                  actualRunners.push(runners[1]);
              }
              count = count + countBets(actualRunners, legs, combine, maxCount, ordered);
          }
          break;
      case "keybox":
          if ((runners.length !== legs) || !ordered) return -1;
          count = countKeyBoxBets(runners, legs, combine, false, maxCount, ordered);
          break;
      case "wheel":
          count = countBets(runners, legs, combine, maxCount, ordered);
          break;
      default:
          if (runners.length != races * legs) return -1;
          for (let m = 0; m < legs; m++) {
              if (runners[m].length < 1) return -1;
          }
          count = countBets(runners, legs, combine, maxCount, ordered);
          break;
  }
  return count;
};

const countKeyBoxBets = (
  parsedRunners: any, legs: any, combine: any, removeDuplicates: any, maxCount: any, ordered: any
) => {
  let count = 0;
  let possibleLegPositions = [];
  for (let i = 0; i < legs; i++) {
      const innerPerm = [];
      for (let j = 0; j < legs; j++) {
          innerPerm.push(j);
      }
      possibleLegPositions.push(innerPerm);
  }
  possibleLegPositions = getPerms(possibleLegPositions, [], 0, null, maxCount);
  if (possibleLegPositions === null) return -2;
  let uniqueBets: any;
  uniqueBets = {};
  for (let k = 0; k < possibleLegPositions.length; k++) {
      if (count < 0) return count;
      const actualRunners = [];
      for (let l = 0; l < possibleLegPositions[k].length; l++) {
          actualRunners.push(parsedRunners[possibleLegPositions[k][l]]);
      }
      if (removeDuplicates) {
          let betPermRunners;
          const betPerms = getPerms(actualRunners, [], 0, null, maxCount);
          if (betPerms === null) return -2;
          for (let m = 0; m < betPerms.length; m++) {
              betPermRunners = betPerms[m][0];
              for (let n = 1; n < betPerms[m].length; n++) {
                  betPermRunners = betPermRunners + "," + betPerms[m][n];
              }
              uniqueBets[betPermRunners] = true;
          }
      } else {
          count = count + countBets(actualRunners, legs, combine, maxCount, ordered);
      }
  }
  if (removeDuplicates) {
      count = Object.keys(uniqueBets).length;
  }
  return count;
};

export const countBets = (runners: any, legs: any, combine: any, maxCount: any, ordered: any) => {
  let count;
  if (ordered) {
      count = legs === 1 ? countSingle(runners, maxCount) : countPerms(runners, [], 0, 0, maxCount);
  } else {
      count = countCombos(runners, maxCount);
  }
  return count < 0 ? count : (combine < 1 ? 1 : combine) * count;
};

const countSingle = (runners: any, maxCount?: any) => {
  let count = 1;
  if (runners.length === 0) return 0;

  for (let leg = 0; leg < runners.length; leg++) {
      count = count * runners[leg].length;
  }
  return count;
};

const countCombos = (runners: any, maxCount: any) => {
  const allCombos = getCombos(runners, [], 0, {}, maxCount);
  return Object.keys(allCombos).length;
};

const getCombos = (
  runners: any,
  permSoFar: any,
  curIndex: any,
  allCombos: any,
  maxCount: any,
  unorderedPool?: any,
  races?: any
) => {
  if(unorderedPool == null) {
      unorderedPool = true;
  }
  if(races == null) {
      races = 1;
  }
  if (!allCombos) {
      allCombos = {};
  }
  for (let i = 0; i < runners[curIndex].length; i++) {
      if (permSoFar.indexOf(runners[curIndex][i]) === -1 || races > 1) {
          permSoFar.push(runners[curIndex][i]);
          if (curIndex + 1 != runners.length) {
              allCombos = getCombos(
                runners,
                permSoFar,
                curIndex + 1,
                allCombos,
                maxCount,
                unorderedPool,
                races
              );
              if (allCombos === null) return null;
          } else {
            const clonedPerm = clone(permSoFar);
              if (unorderedPool) {
                  clonedPerm.sort();
              }
              let permSoFarString = clonedPerm[0];
              for (let j = 1; j < clonedPerm.length; j++) {
                  permSoFarString = permSoFarString + "/" + clonedPerm[j];
              }
              allCombos[permSoFarString] = true;
          }
          permSoFar.pop();
      }
  }
  return allCombos;
};

const getPerms = (runners: any, permSoFar: any, curIndex: any, allPerms: any, maxCount: any) => {
  if (!allPerms) {
      allPerms = [];
  }
  for (let i = 0; i < runners[curIndex].length; i++) {
      if (permSoFar.indexOf(runners[curIndex][i]) === -1) {
          permSoFar.push(runners[curIndex][i]);
          if (curIndex + 1 != runners.length) {
              allPerms = getPerms(runners, permSoFar, curIndex + 1, allPerms, maxCount);
              if (allPerms === null) return null;
          } else {
            const clonedPerm = clone(permSoFar); // needs clone not refernce!
              allPerms.push(clonedPerm);
          }
          permSoFar.pop();
      }
  }
  return allPerms;
};

const countPerms = (runners: any, permSoFar: any, curIndex: any, curCount: any, maxCount?: any) => {
  for (let i = 0; i < runners[curIndex].length; i++) {
      if (permSoFar.indexOf(runners[curIndex][i]) === -1) {
          permSoFar.push(runners[curIndex][i]);
          if (curIndex + 1 !== runners.length) {
              curCount = countPerms(runners, permSoFar, curIndex + 1, curCount);
              if (curCount < 0) return curCount;
          } else {
              curCount++;
          }

          permSoFar.pop();
      }
  }
  return curCount;
};

const toteCompressedStringToList = (compressedString: any) => {
  compressedString = compressedString.replace("+",",");
  const numberSplit = compressedString.split(",");
  const convertedNumbers = [];
  for (let i = 0; i < numberSplit.length; i++) {
      if (!isNaN(numberSplit[i])) {
          convertedNumbers.push(numberSplit[i]);
      } else {
          if (numberSplit[i].indexOf("-") < 0) continue;

          const splitRange = numberSplit[i].split("-");
          if (splitRange.length !== 2) continue;

          for (let j = splitRange[0]; j <= splitRange[1]; j++) {
              convertedNumbers.push(j);
          }
      }
  }
  return convertedNumbers;
}

const clone = (obj: any) => {
  if (obj === null || typeof (obj) !== "object" || "isActiveClone" in obj) return obj;
  let temp;
  if (obj instanceof Date)
    // temp = new obj.constructor();
      temp = new (obj.constructor as any)();
  else
      temp = obj.constructor();

  for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
          obj["isActiveClone"] = null;
          temp[key] = clone(obj[key]);
          delete obj["isActiveClone"];
      }
  }
  return temp;
};
